<template>
  <div id="projectManage" v-if="divVisible">
    <b>プロジェクト情報管理画面</b><br/><br/>

    <table>
      <tr>
        <td>プロジェクト情報を管理いただきます。</td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader" class="table table-striped">
          <tbody>
            <tr>
              <td><b>プロジェクトID：</b></td>
              <td><input type="text" style="width: 40%;" v-bind:disabled="''" v-model="rows[0].projectInfo.projectID"></td>
            </tr>
            <tr>
              <td><b>プロジェクト名：</b></td>
              <td><input type="text" style="width: 100%;" v-bind:disabled="rows[0].operationType == 'delete'" maxlength="1024" v-model="rows[0].projectInfo.projectName"></td>
            </tr>
            <tr>
              <td><b>プロジェクト開発部門名：</b></td>
              <td><input type="text" style="width: 100%;" v-bind:disabled="rows[0].operationType == 'delete'" maxlength="255" v-model="rows[0].projectInfo.organizationName"></td>
            </tr>
            <tr>
              <td><b>プロジェクト概要：</b></td>
              <td><input type="text" style="width: 100%;" v-bind:disabled="rows[0].operationType == 'delete'" maxlength="1024" v-model="rows[0].projectInfo.overview"></td>
            </tr>
            <tr>
              <td><b>プロジェクト期間：</b></td>
              <td>
                <input type="date" v-bind:disabled="rows[0].operationType == 'delete' || rows[0].operationType == 'modify'" v-model="rows[0].projectInfo.startDate">
                &nbsp;～&nbsp;
                <input type="date" v-bind:disabled="rows[0].operationType == 'delete'" v-model="rows[0].projectInfo.endDate">
              </td>
            </tr>
          </tbody>
        </table>
      </div><br/>
      <button id="saveBtn" v-on:click="processClick" class="btn-mid" style="width:250px;" v-if="rows[0].operationType == 'delete'">削除</button>&nbsp;
      <button id="saveBtn" v-on:click="processClick" class="btn-mid" style="width:250px;" v-if="rows[0].operationType == 'modify'">変更</button>&nbsp;
      <button id="saveBtn" v-on:click="processClick" class="btn-mid" style="width:250px;" v-if="rows[0].operationType == 'create'">新規</button>&nbsp;
      <button @click="$router.back(-1);" class="btn-mid" style="width:250px;">キャンセル</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "projectManage",
    data() {
      return {
          divVisible: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          // heads: [ ],
          rows:  [ { operationType: '',
                     projectInfo: { projectID: '', projectName: '', organizationName: '', overview: '', startDate: '', endDate: '', deleteFlg: '' } },
                 ],
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/projectManageInit", data)
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                // self.heads = res.data.heads;
                self.rows = res.data.rows;

                // // 削除・変更の場合
                // self.user = { memberID: '100002 ', memberName: '松下太郎', userType: '5', deleteFlg: '0' };
                // self.heads = [ ];
                // self.rows =
                //   [
                //     { operationType: 'modify',
                //       projectInfo: { projectID: '10000000', projectName: 'SN評価システム', organizationName: '第一開発部', overview: 'プロジェクト担当者を評価実施します。', startDate: '2019-12-01', endDate: '2020-04-30', deleteFlg: '0' } },
                //   ];

                // // 新規の場合
                // self.user = { memberID: '100002 ', memberName: '松下太郎', userType: '5', deleteFlg: '0' };
                // self.heads = [ ];
                // self.rows =
                //   [
                //     { operationType: 'create',
                //       projectInfo: { projectID: '', projectName: '', organizationName: '', overview: '', startDate: '', endDate: '', deleteFlg: '' } },
                //   ];

                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });
      },
      processClick: function () {
        var self = this;
        var data = { rowData:JSON.stringify(self.rows[0]) };
        $("#saveBtn").attr("disabled", true);
        common.getAxios().post(process.env.API_URL +"/api/projectManageProcess", data)
          .then(function (res) {
            $("#saveBtn").attr("disabled", false);
            // 処理正常の場合
            if (res.data == '') {
              self.$router.push({ name: 'projects', params: { } });
            }
            // 処理エラーの場合
            else {
              alert(res.data);
            }
          })
          .catch(function (err) {
            $("#saveBtn").attr("disabled", false);
            alert(err);
          });
      },

    }
  };
</script>



// WEBPACK FOOTER //
// projectManage.vue?a6a86aa2